import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AUTH_INDICATOR } from 'src/app/global/enums/auth-indicator.enum';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { TipoProductoEnum } from 'src/app/global/enums/tipo-producto.enum';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { environment } from 'src/environments/environment';
import { TagManagerService } from '../../../../global/services/tag-manager.service';
import { ConfiguracionProductoPJComponent } from './persona-juridica/configuracion-producto-pj/configuracion-producto-pj.component';
import { CuentaBancariaPJComponent } from './persona-juridica/cuenta-bancaria-pj/cuenta-bancaria-pj.component';
import { DatosEmpresaComponent } from './persona-juridica/datos-empresa/datos-empresa.component';
import { DatosSocioComponent } from './persona-juridica/datos-socio/datos-socio.component';
import { DeclaracionJuradaComponent } from './persona-juridica/declaracion-jurada/declaracion-jurada.component';
import { ConfiguracionProductoComponent } from './persona-natural/configuracion-producto/configuracion-producto.component';
import { CuentaBancariaComponent } from './persona-natural/cuenta-bancaria/cuenta-bancaria.component';
import { DatosAdjuntosComponent } from './persona-natural/datos-adjuntos/datos-adjuntos.component';
import { DatosComercioComponent } from './persona-natural/datos-comercio/datos-comercio.component';
import { DatosPersonalesCiComponent } from './persona-natural/datos-personales-ci/datos-personales-ci.component';
import { DatosPersonalesComponent } from './persona-natural/datos-personales/datos-personales.component';


@Component({
  selector: 'app-paso-dos',
  templateUrl: './paso-dos.component.html',
  styleUrls: ['./paso-dos.component.scss']
})
export class PasoDosComponent implements AfterViewInit, OnInit, AfterContentChecked {
  private retomaConfig = environment.retoma;
  public isRetoma: boolean;
  @Output() nextStep: EventEmitter<any> = new EventEmitter();

  @ViewChild(DatosPersonalesComponent, { static: false }) datosPersonales: DatosPersonalesComponent;
  @ViewChild(DatosPersonalesCiComponent, { static: false }) datosPersonalesCi: DatosPersonalesCiComponent;
  @ViewChild(DatosComercioComponent, { static: false }) datosComercio: DatosComercioComponent;
  @ViewChild(DatosEmpresaComponent, { static: false }) datosEmpresa: DatosEmpresaComponent;
  @ViewChild(DatosSocioComponent, { static: false }) datosSocios: DatosSocioComponent;
  @ViewChild(ConfiguracionProductoComponent, { static: false }) configuracionProducto: ConfiguracionProductoComponent;
  @ViewChild(ConfiguracionProductoPJComponent, { static: false }) configuracionProductoPJ: ConfiguracionProductoPJComponent;
  @ViewChild(DatosAdjuntosComponent, { static: false }) datosAdjuntos: DatosAdjuntosComponent;
  @ViewChild(CuentaBancariaComponent, { static: false }) cuentaBancaria: CuentaBancariaComponent;
  @ViewChild(CuentaBancariaPJComponent, { static: false }) cuentaBancariaPJ: CuentaBancariaPJComponent;
  @ViewChild(DeclaracionJuradaComponent, { static: false }) declaracionUAF: DeclaracionJuradaComponent;

  innerWidth: number = window.innerWidth;

  showInfoMessage = true;
  showInfoMessagePJ = true;
  producto: Product;

  isPersonaNatural: boolean = this.storage.getPaso1Login().currentIsPersonaNatural;

  get flujos() {
    if (this.isPersonaNatural) {
      return this.flujosPaso2Serv;
    } else {
      return this.flujosPaso2PJServ;
    }
  }

  public datosPersonalesForm: FormGroup = new FormGroup({
    nombre: new FormControl('', [
      Validators.required
    ])
  });

  constructor(
    private router: Router,
    private flujosPaso2Serv: FlujosPaso2Service,
    private flujosPaso2PJServ: FlujosPaso2PJService,
    private carroService: CarroComprasService,
    private storage: LocalStorageService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private tagM:TagManagerService
  ) { }

  ngOnInit(): void {
    this.flujosPaso2Serv.configuracionProducto.mostrar = false;
    this.flujosPaso2PJServ.configuracionProducto.mostrar = false;
    this.route.queryParams
      .subscribe(params => {
        this.isRetoma = params.action == AUTH_INDICATOR.IS_RETOMA;
      }
      );
  }

  ngAfterViewInit() {
    const data = this.storage.getPaso1Login();
    if (this.isPersonaNatural) {
      this.tagM.logEvent(GoogleTagManager.eventPageView().datosPersonales());
      this.tagM.logEvent(GoogleTagManager.eventBeginChekout().setEtiqueta(this.carroService.getCurrentProduct().title).setOrigen(window.location.href));
      if (data.retoma == AUTH_INDICATOR.EMPTY_STRING) {
        this.getDatosPersonalesCI();
      } else {
        this.getDatosPersonales();
      }
    } else {
      this.getDatosEmpresa();
    }
  }

  ngAfterContentChecked() {
    this.validarProducto();
  }

  validarProducto() {
    this.producto = this.carroService.getCurrentProduct();
    if (this.producto) {
      if ((this.producto.tipoProducto === TipoProductoEnum.SERVICIO_WEB && this.producto.codigoProducto !== CodigoProductoEnum.COBRO_QR)
        || this.producto.codigoProducto === CodigoProductoEnum.PACK_VENTA_MPOS_LP
        || this.producto.codigoProducto === CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA
        || this.producto.codigoProducto === CodigoProductoEnum.PACK_POS_MOVIL_LP) {
        if (this.isPersonaNatural) {
          this.flujosPaso2Serv.configuracionProducto.visible = true;
        } else {
          this.flujosPaso2PJServ.configuracionProducto.visible = true;
        }
      } else {
        if (this.isPersonaNatural) {
          this.flujosPaso2Serv.configuracionProducto.visible = false;
        } else {
          this.flujosPaso2PJServ.configuracionProducto.visible = false;
        }
      }

      if (this.producto.tipoProducto === TipoProductoEnum.SERVICIO_WEB || this.producto.codigoProducto === CodigoProductoEnum.COBRO_QR) {
        this.showInfoMessage = false;
        this.showInfoMessagePJ = false;
      } else {
        this.showInfoMessage = true;
        this.showInfoMessagePJ = true;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  get showCantidadCampos(): boolean {
    return this.innerWidth >= 800;
  }

  get showCantidadCamposPJ(): boolean {
    return this.innerWidth >= 800;
  }

  getDatosPersonales(): void {
    this.datosPersonales.init();
  }

  getDatosPersonalesCI(): void {
    this.datosPersonalesCi.init();
  }

  getDatosEmpresa(): void {
    this.datosEmpresa.init();
  }

  onNextStepClick(event): void {
    const gevent = GoogleTagManager.eventInteracciones().categoriaCuentaBancaria().setAccion("check");
    this.tagM.logEvent(gevent.setEtiqueta("completo"));
    this.nextStep.emit();
  }

  paso1Ok() {
    // inicializar paso 2

    if (this.isPersonaNatural) {
      const gevent = GoogleTagManager.eventInteracciones().categriaDatosPersonales().setAccion("check");
      this.tagM.logEvent(gevent.setEtiqueta("completo").setIsPersonaNatural(this.isPersonaNatural));
      this.datosComercio.init();
    } else {
      this.flujosPaso2PJServ.datosSocio.cargando = true;
      this.flujosPaso2PJServ.datosSocio.bloqueado = false;
      this.datosSocios.init();
    }
  }

  paso2Ok() {
    // inicializar paso 3
    if (this.isPersonaNatural) {
      const gevent = GoogleTagManager.eventInteracciones().categoriaDatosDeComercio().setAccion("check");
      this.tagM.logEvent(gevent.setEtiqueta("completo").setIsPersonaNatural(this.isPersonaNatural));
      if (this.flujosPaso2Serv.configuracionProducto.visible) {
        this.flujosPaso2Serv.configuracionProducto.cargando = true;
        this.configuracionProducto.init();
      } else {
        this.flujosPaso2Serv.configuracionProducto.cargando = false;
        this.flujosPaso2Serv.configuracionProducto.mostrar = false;
        this.flujosPaso2Serv.configuracionProducto.ok = true;
        this.flujosPaso2Serv.datosAdjuntos.cargando = true;
        this.flujosPaso2Serv.datosAdjuntos.bloqueado = false;
        this.datosAdjuntos.init();
      }
    } else {
      if (this.flujosPaso2PJServ.configuracionProducto.visible) {
        this.flujosPaso2PJServ.configuracionProducto.cargando = true;
        this.configuracionProductoPJ.init();
      } else {
        this.flujosPaso2Serv.configuracionProducto.cargando = false;
        this.flujosPaso2Serv.configuracionProducto.mostrar = false;
        this.flujosPaso2Serv.configuracionProducto.ok = true;
        this.flujosPaso2PJServ.formularioUAF.cargando = true;
        this.flujosPaso2PJServ.formularioUAF.bloqueado = false;
        this.declaracionUAF.init();
      }
    }
  }

  paso3Ok() {
    const gevent = GoogleTagManager.eventInteracciones().categoriaConfiguracionDeProducto().setAccion("check");
    this.tagM.logEvent(gevent.setEtiqueta("completo").setIsPersonaNatural(this.isPersonaNatural));
    if (this.isPersonaNatural) {
      this.flujosPaso2Serv.datosAdjuntos.cargando = true;
      if (this.datosAdjuntos) { this.datosAdjuntos.init(); }
    } else {
      this.flujosPaso2PJServ.formularioUAF.cargando = true;
      this.declaracionUAF.init();
    }
  }

  paso4Ok() {
    this.flujosPaso2Serv.datosAdjuntos.cargando = true;
    this.datosAdjuntos.init();
  }

  paso5Ok() {
    const gevent = GoogleTagManager.eventInteracciones().categoriaAdjuntarDocumentos().setAccion("check");
    this.tagM.logEvent(gevent.setEtiqueta("completo").setIsPersonaNatural(this.isPersonaNatural));
    this.tagM.logEvent(GoogleTagManager.eventPageView().ctaBancariaAbono());
    if (this.isPersonaNatural) {
      this.cuentaBancaria.init();
    } else {
      this.cuentaBancariaPJ.init();
    }
  }

}
